//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PriceHistoryPopup',
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    apartmentId: {
      type: String,
      required: true,
    },
    investmentId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      error: null,
      priceHistory: [],
    };
  },
  computed: {
    sortedPriceHistory() {
      return [...this.priceHistory].sort(
        (a, b) => new Date(b.datetime) - new Date(a.datetime)
      );
    },
  },
  watch: {
    isVisible(newValue) {
      if (newValue) {
        this.fetchPriceHistory();
      }
    },
  },
  methods: {
    closePopup() {
      this.$emit('close');
    },

    fetchPriceHistory() {
      this.loading = true;
      this.error = null;
      this.priceHistory = [];

      try {
        // Check if data is already available in window
        if (window.priceHistory && window.priceHistory.apartments) {
          const apartment = window.priceHistory.apartments.find(
            apt => apt.id === this.apartmentId
          );

          if (apartment && apartment.priceHistory) {
            this.priceHistory = apartment.priceHistory;
          } else {
            this.error = 'Nie znaleziono historii cen dla tego lokalu';
          }
        } else {
          this.error = 'Dane historii cen nie są dostępne';
        }
      } catch (error) {
        console.error('Error getting price history:', error);
        this.error = 'Błąd podczas pobierania historii cen';
      } finally {
        this.loading = false;
      }
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('pl-PL', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });
    },

    formatPrice(price) {
      if (price === undefined || price === null) return '-';
      return (
        Number(price).toLocaleString('pl-PL', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }) + ' zł'
      );
    },
  },
};



// WEBPACK FOOTER //
// ./scripts/vue/partials/PriceHistoryPopup.vue